import { v4 as uuidv4 } from 'uuid';
import { getDotsByCount, startProgressUpdater, stopProgressUpdater } from '../../../../commons/utils/counter';

const messages = ['Loading', 'Please wait', 'Almost done'];

export function startSubscriptionProgress() {
    startProgressUpdater({
        key: 'ecalWorldSubscriptionsListProgress',
        store: this,
        messageInterval: 3,
        messageUpdateCallback: updateSubscriptionProgressMessage,
        dotsUpdateCallback: updateSubscriptionProgressDots,
    });
    this.loadProgress.subscriptions = true;
    this.observed.loadProgress = uuidv4();
}

export function stopSubscriptionProgress() {
    stopProgressUpdater('ecalWorldSubscriptionsListProgress');
    this.loadProgress.subscriptions = false;
    this.observed.loadProgress = uuidv4();
}

function updateSubscriptionProgressMessage(store) {
    store.loadProgress.messageStep += 1;
    if (store.loadProgress.messageStep >= 3) store.loadProgress.messageStep = 0;
    store.loadProgress.message = messages[store.loadProgress.messageStep];
    store.loadProgress.progressLabel = store.loadProgress.message + store.loadProgress.dots;
    store.observed.loadProgress = uuidv4();
}

function updateSubscriptionProgressDots(store) {
    store.loadProgress.dotsCount += 1;
    if (store.loadProgress.dotsCount > 3) store.loadProgress.dotsCount = 0;
    store.loadProgress.dots = getDotsByCount(store.loadProgress.dotsCount);
    store.loadProgress.progressLabel = store.loadProgress.message + store.loadProgress.dots;
    store.observed.loadProgress = uuidv4();
}
